export default{
    energyConsumption: '能耗分析',
    chargeDischargeEfficiency: '充放电效率',
    selfConsumption: '自耗电量'
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/energyConsumption.js